import { i18nMark } from 'lingui-react';

const messages = {
  breadcrumbs: i18nMark('Request {number}'),
  description: i18nMark('The Service Request Detail page of the application'),
  title: i18nMark('The Service Request Detail Page'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/ServiceRequestDetailData/messages.js